import { RDEqipFsaForms } from '@cibo/core'
import { ResourceDetailFeature } from '@cibo/ui'
import { RDEqipFsaFormsTaskEditor } from './RDEqipFsaFormsTaskEditor'

export const RDEqipFsaFormsResourceDetailFeature: ResourceDetailFeature<RDEqipFsaForms> = {
  traitId: 'eqipFsaForms',
  TaskEditor: RDEqipFsaFormsTaskEditor,
}
